module.exports = __webpack_public_path__ + "img/more.6b1afc2c.svg";